<template>
  <!-- 产品服务-智慧车城 -->
  <div class="box zhcc">
    <div v-if="!isM" class="cc0 bgimg"></div>
    <div v-if="isM" class="ccm0"></div>

    <div class="cc1">
      <div class="min_box">
        <div>
          <h4 class="blue_h4">智慧车城管理平台</h4>
          <p class="gary_dec">
            智慧车城管理平台将移动终端融入汽车消费体验，集线上展示、互动交流、在线比价、线下体验等功能为一体，将科技转化为便捷的智能导购系统；并同时为车商提供一站式数字化智能管理平台，对门店客户及车辆进行移动化、数字化管理。
          </p>
        </div>
        <img class="wlphobe" :src="picUrl + 'ccphone.png'" alt="车镇物流" />
      </div>
    </div>

    <div class="cc2">
      <div class="min_box">
        <h4 class="blue_h4">智能导购系统</h4>
        <p class="gary_dec">颠覆传统购车体验</p>
        <ul class="cc4_ul">
          <li v-for="(item, index) in arr" :key="item.id">
            <img :src="picUrl + 'cc' + (index + 1) + '.jpg'" :alt="item.name" />
            <div>
              <p>{{ item.tit }}</p>
              <span>{{ item.dec }}</span>
              <span>{{ item.des }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="cc3">
      <div class="min_box">
        <h4 class="blue_h4">智能管理平台</h4>
        <p class="gary_dec">赋能企业数字化未来</p>
        <ul class="cc3_ul">
          <li v-for="(item, index) in arr1" :key="item.id">
            <div class="c3_top">
              <img
                :src="picUrl + 'ccb' + (index + 1) + '.jpg'"
                :alt="item.name"
              />
              <p>{{ item.tit }}</p>
            </div>
            <div class="c3_bottom">
              <p>{{ item.dec }}</p>
              <span>{{ item.des }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Zhcc",
  data() {
    return {
      picUrl: this.$root.picUrl,
      arr: [
        {
          tit: "智能人机交互系统",
          dec: "在线展示车源信息",
          des: "车型、图片、价格一应俱全",
        },
        {
          tit: "智能在线客服系统",
          dec: "专业汽车销售顾问 ",
          des: "一对一实时互动交流",
        },
        {
          tit: "智能驾驶模拟系统",
          dec: "真实虚拟3D的视角",
          des: "给你前所未有的真实体验",
        },
      ],
      arr1: [
        {
          tit: "销售智能管理系统 ",
          dec: "售前>售中>售后",
          des: "客户全生命周期移动化、数字化管理",
        },
        {
          tit: "车辆智能监管系统",
          dec: "入库>在库>出库",
          des: "车辆位置/行车轨迹移动化、数字化管理",
        },
      ],
      isM: false,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
  },
};
</script>



// WEBPACK FOOTER //
// src/views/Proservices/zhcc.vue